<div id="billing-cycles-display-page-wrapper">
  <app-billing-cycles-table class="full-height-width"></app-billing-cycles-table>
</div>
